module.exports = __webpack_public_path__ + "static/media/kuberneteslogo.c0e32d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/kuberneteslogo.png
// module id = 839
// module chunks = 0